import { useState } from 'react';

import { nextTableSort } from '../../utils/nextTableSort';

/**
 * Estado de orden de una tabla: cada clic alterna ascendente, descendente y sin orden.
 * @param {Function} [onChange] Se llama en cada cambio (por ejemplo, para volver a la página 1).
 * @returns {{sort: Object|null, toggleSort: Function, resetSort: Function, sortParams: Object}}
 *   `sortParams` trae `sort_by` y `sort_dir` listos para la consulta al backend.
 */
export const useTableSort = (onChange) => {
  const [sort, setSort] = useState(null);

  const toggleSort = (key) => {
    setSort((current) => nextTableSort(current, key));
    if (onChange) onChange();
  };

  return {
    sort,
    toggleSort,
    resetSort: () => setSort(null),
    sortParams: sort ? { sort_by: sort.key, sort_dir: sort.direction } : {},
  };
};
